import Swiper from 'swiper/swiper-bundle';
import Viewer from 'viewerjs';

class SliderSectionV2 {
    constructor(section) {
        this.section = section;
        this.isLightboxEnabled = this.section.dataset.lightbox === 'true';

        this.initSlider();

        if (this.isLightboxEnabled) {
            this.initImageViewer();
        }
    }

    initSlider() {
        const nextButton = this.section.querySelector('.js-slider-section-v2__button--next');
        const prevButton = this.section.querySelector('.js-slider-section-v2__button--prev');
        const pagination = this.section.querySelector('.js-slider-section-v2__pagination');

        this.slider = new Swiper(this.section.querySelector('.swiper-container'), {
            slidesPerView: 1,
            resizeObserver: true,
            loop: true,
            autoHeight: true,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            pagination: {
                el: pagination,
                clickable: true
            },
            speed: 500,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
        });
    }

    initImageViewer() {
        const images = this.section.querySelectorAll('.js-slider-section-v2__slide-image');

        if (!images.length) return;

        images.forEach(image => {
            new Viewer(image, {
                toolbar: false,
                navbar: false,
                title: false,
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.js-slider-section-v2');

    if (!sections.length) return;

    sections.forEach(section => {
        new SliderSectionV2(section);
    });
});